import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faq } from '../../data/faq';
import { CTAButton } from '../CTAButton';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-mist py-14 md:py-20" aria-labelledby="faq-title" data-id="element-117" data-mp="2u5fh5i0yv04y">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-118" data-mp="2z49z6hr40ko0">
        <h2 id="faq-title" className="text-center font-display text-[26px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-119" data-mp="3mst8n0lwb3ho">
          Frequently Asked Questions
        </h2>

        <ul className="mt-8 space-y-3 md:mt-12" data-id="element-120" data-mp="3d3ru7ev00u5t">
          {faq.map((item, i) => {
          const isOpen = open === i;
          return <li key={item.question} className="overflow-hidden rounded-2xl border border-navy-900/10 bg-white" data-id="element-121" data-mp="3i0034ailrr4j" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-mist" data-id="element-122" data-mp="ee1e3la4byx4">
                  <span className="text-[15px] font-bold leading-snug text-navy-950" data-id="element-123" data-mp="2ahumg8f7phjw">{item.question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-124" data-mp="25nqf3o21b7ia" />
                </button>
                {isOpen && <p className="border-t border-navy-900/5 px-5 py-4 text-[14px] leading-relaxed text-navy-800/80" data-id="element-125" data-mp="2ogkkprdrpn9u">
                    {item.answer}
                  </p>}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-126" data-mp="u3unp0s3rxy8">
          <p className="font-display text-lg font-black uppercase leading-tight text-navy-950 sm:text-2xl" data-id="element-127" data-mp="1jqxd3skqtfx5">
            No more scattered case files. No more starting from a blank page.
            <span className="mt-1 block text-brand-600" data-id="element-128" data-mp="1srdfsztnwj0y">One command center.</span>
          </p>
          <div className="mt-6" data-id="element-129" data-mp="1xq6qyllh7xxy">
            <CTAButton data-id="element-130" data-mp="1xr84qxtvmyjd" />
          </div>
        </div>
      </div>
    </section>;
}